import React from "react";
import Navbar from "./Navbar";
import "./scrolling.css";
import Footer from "./Footer";
const About = () => {
  return (
    <div className=" bg-[#fff7f1]   justify-around overflow-hidden">
      <Navbar />
      <div className=" h-1/2 bg-blue-500 w-1/2 absolute z-[999] -left-40 -top-1 rounded-full  opacity-30 blur-3xl  " />
      <div className=" h-1/2 bg-green-400 w-1/3 absolute z-[999] -left-40 top-0 rounded-full  opacity-20 blur-3xl  " />

      <div className=" text-center pt-14 flex flex-col gap-5">
        <h1 className=" league-spartan-extrabold text-3xl md:text-6xl pt-40 textanime">
          About
        </h1>
        <h2 className=" text-xl text-gray-400 font-semibold textanime textanime2">
          Get to know a little more about me.{" "}
        </h2>
      </div>
      <div className=" px-8 text-md sm:text-xl md:text-2xl text-wrap py-8 sm:py-32 md:px-56   tracking-wider place-self-center">
        <p>
          I am a dedicated full-stack developer with a robust understanding of
          both front-end and back-end technologies. My primary focus is on
          developing dynamic and efficient web applications that emphasize
          functionality, user experience, and high-quality code. Currently, I am
          deepening my knowledge in backend development, particularly in
          microservice architecture, to create scalable and modular systems.
        </p>
        <br />
        <p>
          I am committed to continuous learning and staying current with the
          latest industry trends and best practices. Whether working
          collaboratively or independently, I approach complex challenges with a
          problem-solving attitude. This dedication allows me to deliver
          outstanding results across various projects and contribute to the
          advancement of innovative web applications.
        </p>
      </div>
      <div className="scrolling_text h-fit flex gap-5 text-xl sm:text-6xl md:text-8xl">
        <div className="text flex h-fit gap-5 ">
          <span> REACT.JS </span>
          <span>EXPRESS.JS </span>
          <span>JAVASCRIPT </span>
          <span>EXPRESS.JS </span>
          <span>REACT.JS </span>
          <span>EXPRESS.JS </span>
          <span>JAVASCRIPT </span>
          <span> EXPRESS.JS </span>
        </div>
        <div className="text flex h-fit gap-5 ">
          <span> REACT.JS </span>
          <span>EXPRESS.JS </span>
          <span>JAVASCRIPT </span>
          <span>EXPRESS.JS </span>
          <span>REACT.JS </span>
          <span>EXPRESS.JS </span>
          <span>JAVASCRIPT </span>
          <span> EXPRESS.JS </span>
        </div>
      </div>
      <div className="scrolling_text text-xl  flex gap-5 top-1/2 sm:text-6xl md:text-8xl">
        <div className="text flex gap-5 ">
          <span> Node.JS </span>
          <span> C# </span>
          <span> C++ </span>
          <span> Java </span>
          <span> Python </span>
          <span> Node.JS </span>
          <span> C# </span>
          <span> C++ </span>
          <span> Java </span>
          <span> Python </span>
        </div>
        <div className="text flex gap-5 ">
          <span> Node.JS </span>
          <span> C# </span>
          <span> C++ </span>
          <span> Java </span>
          <span> Python </span>
          <span> Node.JS </span>
          <span> C </span>
          <span> C++ </span>
          <span> Java </span>
          <span> Python </span>
        </div>
      </div>
      <div className=" flex justify-evenly mt-9">
        <a
          href="https://www.linkedin.com/in/hemil-dudhat-52ab51265/"
          class="bg-muted   rounded-xl border  inline-block hover:opacity-80 transition-opacity transition-duration-300 relative "
        >
          <div class="flex flex-col scale-95 md:scale-100 p-3 md:p-5 space-y-3  md:space-y-5 justify-center items-center rounded-xl  bg-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="35"
              height="35"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="block align-middle relative -top-[1px]"
            >
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
              <rect x="2" y="9" width="4" height="12"></rect>
              <circle cx="4" cy="4" r="2"></circle>
            </svg>
            <span class="font-semibold text-center">LinkedIn</span>
          </div>
          <div class="absolute top-0 right-0 mt-2 mr-2 text-muted-foreground">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="7" y1="17" x2="17" y2="7"></line>
              <polyline points="7 7 17 7 17 17"></polyline>
            </svg>
          </div>
        </a>
      </div>
      <Footer />
    </div>
  );
};

export default About;
